import logError from "seneca-common/utils/sentry/logError";

const LOCAL_STORAGE_KEY = "forcedSignOut";

export function setForcedSignOut() {
  try {
    window.localStorage &&
      window.localStorage.setItem(LOCAL_STORAGE_KEY, true as unknown as string);
  } catch (err: any) {
    logError(err, {
      message: "Could not set forcedSignOut on localStorage"
    });
  }
}

export function clearForcedSignOut() {
  try {
    window.localStorage && window.localStorage.removeItem(LOCAL_STORAGE_KEY);
  } catch (err: any) {
    logError(err, {
      message: "Could not remove forcedSignOut from localStorage"
    });
  }
}

export function lastSignOutWasForced(): boolean {
  try {
    return window.localStorage
      ? (window.localStorage.getItem(LOCAL_STORAGE_KEY) as unknown as boolean)
      : false;
  } catch (err: any) {
    logError(err, {
      message: "Could not get forcedSignOut from localStorage"
    });
  }

  return false;
}
